import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DsTooltipComponent } from './components/tooltip/tooltip.component';
import { DsTooltipDirective } from './directives/tooltip.directive';
import { OverlayModule } from '@angular/cdk/overlay';
import { DsTooltipReferenceDirective } from './directives/tooltip-reference.directive';
import { DsIconModule } from '@skyeng/libs/shared/ui-kit-v2/icon';

@NgModule({
  imports: [CommonModule, OverlayModule, DsIconModule],
  declarations: [DsTooltipComponent, DsTooltipDirective, DsTooltipReferenceDirective],
  exports: [DsTooltipComponent, DsTooltipDirective, DsTooltipReferenceDirective],
})
export class DsTooltipModule {}
